import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SelectGroovyScriptComponent } from '../../../components/select-groovy-script/select-groovy-script.component';
import { ConfiguratorEtlService, EtlScriptDTO } from '@tj/tj-dmp-lib-api';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ComponentsModule } from '../../../components/components.module';


@Component({
    selector: 'dmp-etl-script-update',
    templateUrl: './etl-script-update.component.html',
    styleUrls: ['./etl-script-update.component.scss'],
    standalone: true,
    imports: [SelectGroovyScriptComponent, ButtonModule, TranslateModule, FormsModule, ReactiveFormsModule, ToastModule, ConfirmPopupModule, ComponentsModule]
})
export class EtlScriptUpdateComponent implements OnInit {
    public directionMode: 'IMPORT' | 'EXPORT';
    public breadcrumb: MenuItem[] = [
        { label: this.translate.instant('menu.flow.label') },
        { label: this.translate.instant('menu.flow.imports'), routerLink: '/h/flux/import-v1/etl' },
        { label: this.translate.instant('menu.imports-settings') }];
    public description = '';

    public id: string = null;
    public datastore: string = null;
    public form = this.fb.group({
        id: [],
        name: [null, [Validators.required, Validators.min(3)]],
        code: [null, []],
        description: [],
        tenant: [null, [Validators.required]],
        script: [null, [Validators.required]],
        cron: []
    });
    public innerPath: string;

    constructor(private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly translate: TranslateService,
        protected fb: UntypedFormBuilder,
        private readonly configuratorEtlService: ConfiguratorEtlService) {
    }

    public ngOnInit(): void {
        this.directionMode = this.route.snapshot.routeConfig.path.includes('import') ? 'IMPORT' : 'EXPORT';

        this.id = this.route.snapshot.paramMap.get('id');
        this.datastore = this.route.snapshot.paramMap.get('tenant');
        if (this.id && this.datastore) {
            this.configuratorEtlService.getScriptImport(this.datastore, this.id).subscribe(r =>
                this.form = this.fb.group({
                    id: [r.id],
                    name: [r.name, [Validators.required, Validators.min(3)]],
                    code: [r.code, []],
                    description: [r.description],
                    tenant: [this.datastore, [Validators.required]],
                    script: [{ label: r.script, value: r.script }, [Validators.required]],
                    cron: [r.schedulers]
                })
            );
        }
        this.innerPath = this.directionMode === 'IMPORT' ? 'import-v1' : 'export';
        const pathI18n = this.directionMode === 'IMPORT' ? 'import' : 'export';

        this.breadcrumb = [
            { label: this.translate.instant('menu.flux') },
            { label: this.translate.instant('menu.' + pathI18n), routerLink: `/h/flux/${this.innerPath}/etl` },
            { label: this.translate.instant('menu.import-settings') }];
    }

    public get formControls() {
        return this.form.controls;
    }

    save() {
        const etlScriptDTO: EtlScriptDTO = {
            ...this.form.value,
            script: this.form.value.script.value
        } as EtlScriptDTO;
        const tenant = this.form.value.tenant as string;
        if (this.directionMode === 'EXPORT') {
            this.configuratorEtlService.updateScriptExport(etlScriptDTO, tenant).subscribe(res => {
                const navigationExtras: NavigationExtras = { state: { message: 'success_updated' } };
                this.router.navigate([`/h/flux/${this.innerPath}/etl`], navigationExtras);
            });
        } else {
            this.configuratorEtlService.updateScriptImport(etlScriptDTO, tenant).subscribe(res => {
                const navigationExtras: NavigationExtras = { state: { message: 'success_updated' } };
                this.router.navigate([`/h/flux/${this.innerPath}/etl`], navigationExtras);
            });
        }
    }

    cancel() {
        this.router.navigate([`/h/flux/${this.innerPath}/etl`]);
    }
}
